import {
  Box,
  Button,
  HStack,
  Icon,
  Select,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useStats } from "react-instantsearch";
import { FiFilter } from "react-icons/fi";
import type { AdCampaignSortOption } from "./utils";
import {
  PERFORMANCE_TIER_COLOR_SCHEME,
  PERFORMANCE_TIER_LEGEND,
} from "./utils";
import CampaignSearchInput from "./CampaignSearchInput";

export default function CampaignsTableHeader({
  title,
  sortOrder,
  onSortChange,
  showLegend = true,
}: {
  title: string;
  sortOrder: AdCampaignSortOption;
  onSortChange: (v: AdCampaignSortOption) => void;
  /** When false, the performance legend (High Performing, etc.) is hidden (e.g. Past Campaigns). */
  showLegend?: boolean;
}) {
  const { nbHits } = useStats();

  return (
    <VStack align="stretch" spacing={3}>
      <HStack
        justify="space-between"
        align="flex-start"
        gap={4}
        flexWrap="wrap"
      >
        <VStack align="flex-start" spacing={1}>
          <HStack align="baseline" gap={2}>
            <Text fontSize="lg" fontWeight="600">
              {title}
            </Text>
            <Text fontSize="lg" color="gray.500" fontWeight="400">
              {nbHits}
            </Text>
          </HStack>
          {showLegend && (
            <HStack gap={4} flexWrap="wrap" spacing={0}>
              {PERFORMANCE_TIER_LEGEND.map(({ tier, label }) => (
                <HStack key={tier} gap={1.5}>
                  <Box
                    w={2}
                    h={2}
                    borderRadius="full"
                    bg={PERFORMANCE_TIER_COLOR_SCHEME[tier]}
                    flexShrink={0}
                  />
                  <Text fontSize="sm" color="gray.600">
                    {label}
                  </Text>
                </HStack>
              ))}
            </HStack>
          )}
        </VStack>
        <HStack gap={2} flexShrink={0}>
          <CampaignSearchInput />
          <Button
            size="md"
            variant="outline"
            leftIcon={<Icon as={FiFilter} />}
            bg="gray.50"
            borderColor="gray.200"
            _hover={{ bg: "gray.100" }}
          >
            Filter
          </Button>
          <Select
            width="160px"
            size="md"
            value={sortOrder}
            onChange={(e) =>
              onSortChange(e.target.value as AdCampaignSortOption)
            }
            bg="gray.50"
            borderColor="gray.200"
          >
            <option value="updated_at_descending">Latest</option>
            <option value="created_at_descending">Created (newest)</option>
            <option value="event_start_at_ascending">
              Event date (soonest)
            </option>
            <option value="event_start_at_descending">
              Event date (latest)
            </option>
            <option value="name_ascending">Name A–Z</option>
          </Select>
        </HStack>
      </HStack>
    </VStack>
  );
}
